export default "__VITE_ASSET__C7CfvO7P__"